<template>
  <!-- Help -->
  <v-menu offset-y>
    <template #activator="{ props }">
      <div
        class="bg-grey-lighten-3 rounded-lg ms-md-4 me-1"
        v-bind="props"
      >
        <v-icon
          v-bind="props"
          icon="mdi-help-circle-outline"
          class="ma-2"
          @click="showHelpDialog = true"
        />
      </div>
    </template>
  </v-menu>

  <!-- Notification -->
  <v-menu offset-y>
    <template #activator="{ props }">
      <div
        class="bg-grey-lighten-3 rounded-lg ms-1 me-4"
        v-bind="props"
      >
        <v-icon
          v-bind="props"
          icon="mdi-bell-outline"
          class="ma-2"
          @click="showNotificationDialog = true"
        />
      </div>
    </template>
  </v-menu>

  <!-- Profile -->
  <v-menu offset-y>
    <template #activator="{ props }">
      <v-avatar
        size="38"
        v-bind="props"
        class="ms-4 me-1 bg-primary"
      >
        <span class="grey-lighten-3">{{ userInitials }}</span>
      </v-avatar>
    </template>
    
    <v-list>
      <!-- User Info -->
      <v-list-item>
        <v-list-item-title class="text-subtitle-1 font-weight-bold">
          {{ user?.getFullName() }}
        </v-list-item-title>
        <v-list-item-subtitle>{{ user?.email }}</v-list-item-subtitle>
      </v-list-item>
      
      <v-divider class="my-2" />
      
      <!-- View Profile -->
      <!-- TODO: LF-2025-03-28 - Add back once Auth0 support added
      <v-list-item
        link
        @click="showProfileDialog = true"
      >
        <template #prepend>
          <v-icon
            icon="mdi-account-outline"
            class="me-2"
          />
        </template>
        <v-list-item-title>View Profile</v-list-item-title>
      </v-list-item>
      -->
      <!-- Sign Out -->
      <v-list-item
        link
        @click="handleLogout"
      >
        <template #prepend>
          <v-icon
            icon="mdi-logout"
            class="me-2"
          />
        </template>
        <v-list-item-title>Sign Out</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>

  <ProfileDialog v-model="showProfileDialog" />

  <HelpDialog v-model="showHelpDialog" />

  <NotificationDialog v-model="showNotificationDialog" />
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { storeToRefs } from 'pinia'
import ProfileDialog from '@/components/profile/ProfileDialog.vue'
import HelpDialog from '@/components/help/HelpDialog.vue'
import NotificationDialog from '@/components/notification/NotificationDialog.vue'

const authStore = useAuthStore()
const { getUser } = storeToRefs(authStore)

const showProfileDialog = ref(false)
const showHelpDialog = ref(false)
const showNotificationDialog = ref(false)

onMounted(async () => {
  if (authStore.isAuthenticated && !authStore.user) {
    await authStore.fetchUser()
  }
})

const user = computed(() => getUser.value)
const userInitials = computed(() => user.value?.getInitials() ?? '')

const handleLogout = async () => {
  try {
    await authStore.logout()
  } catch (error) {
    console.error('Logout failed:', error)
  }
}
</script>
